module.exports = __webpack_public_path__ + "static/media/floculante.dc46ff50.pdf";